// extracted by mini-css-extract-plugin
export default {"muslimBerries":"muslim-berries_muslimBerries__K25dt"};